<template>
    <span class="font-bold"><slot /></span>
</template>

<script>
export default {
    name: 'FontBold'
}
</script>
